import { ReportToken } from "core/slices/models"
import { msalInstance } from "index";
import { MINUTES_BEFORE_EXPIRATION } from "./TokenService";


const getTokenFor = async (reportId: string): Promise<ReportToken> => {
  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts();
  if (!activeAccount && accounts.length === 0) {
    window.location.href = '/'; // the user is not signed in. let's move him to the main page and force login
  }

  const request = {
    scopes: ["https://analysis.windows.net/powerbi/api/Report.Read.All"],
    account: activeAccount || accounts[0],
  };

  return msalInstance.acquireTokenSilent(request)
    .then((authResult) => {
      return {
        token: authResult.accessToken,
        tokenId: authResult.uniqueId,
        expiration: authResult.expiresOn?.toString() || new Date().toString()
      }
    })
}

const validateTokenReportPair = (reportId: string, token: string): boolean => {
  // AD tokens are valid for all reports
  return true
}

const isAboutToExpire = (token: ReportToken): boolean => {
  // Get the current time
  const currentTime = Date.now();
  const expiration = Date.parse(token.expiration);

  // Time until token expiration in milliseconds
  const timeUntilExpiration = expiration - currentTime;
  const timeToUpdate = MINUTES_BEFORE_EXPIRATION * 60 * 1000;

  return timeUntilExpiration <= timeToUpdate
}

export const ADTokenService = {
  getTokenFor,
  isAboutToExpire,
  validateTokenReportPair,
}
